<template>
    <footer class="foot-bg" :class="$route.name=='Home'?'foot-bgw':''">
        <div class="main-container">
            <!--<h4><img src=""/>采购投诉反馈</h4>-->
            <el-row class="foot-title">
                <el-col>
                   <span class="boldLine"></span>采购投诉反馈
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="8">
                    <p >廉政举报电话：0797-8333327</p>
                    <p >廉政举报邮箱：jubao@jfdcgroup.com</p>
                </el-col>
                <el-col :span="10">
                    <p >信件举报：江西省赣州市章贡区橙乡大道嘉福大厦21层 审计监察中心 收</p>
                    <p >邮编：341000</p>
                </el-col>
                <el-col :span="8" class="pic_right">
                    <!-- <img src="../../assets/images/index/fpptLogo.png"/> -->
                </el-col>
            </el-row>
        </div>
        <div>
            <span class="text-center copy">COPYRIGHT © 赣州嘉福投资控股集团有限公司 版权所有</span>
            <span class="text-right  text-center">赣ICP备18005832号-1</span>
        </div>
       <!--  <div class="text-center copy">COPYRIGHT © 赣州嘉福投资控股集团有限公司 版权所有</div>
        <div class="text-right copy">赣ICP备18005832号-1</div> -->
    </footer>
</template>
<script>
    export default {
        name: 'my-footer',
        data() {
            return{

            }
        }
    }
</script>
<style>
    .foot-bg {
        width: 100%;
        min-width:1300px;
        background: #141827;
    }
    .foot-bgw {
        background: #fff;
    }
    .foot-bg .main-container {
        /*margin-bottom: 84px;*/
        margin: 30px auto;
        position: relative;
    }
    .foot-bg .el-col {
        font-size: 14px;
        color: #fff;
        text-align: left;
        line-height: 28px;
    }
    .foot-title .el-col {
        font-size: 16px;
        font-weight: 700;
        margin-top: 24px;
        margin-bottom: 30px;
    }
    .boldLine {
        display: inline-block;
        width: 5px;
        height: 16px;
        background: #fff;
        vertical-align: middle;
        margin-right: 8px;
    }
    .foot-bg .el-col p {margin: 0;padding: 0;}
    .foot-bg .copy {
        height: 40px;
        line-height: 40px;
        font-size: 13px;
        /*color: #C4CACD;*/
        color: #fff;
        background: #2D3336;
    }
    .foot-bg .text-right{
        float: right;
        color: gray;
        height: 40px;
        line-height: 40px;
        font-size: 12px;
        margin-right: 40px;
    }
    .foot-bg .pic_right {
        text-align: right;
    }
    .pic_right img {
        width: 140px;
        height: 136.9px;
        position: absolute;
        right: 10px;
        top: -50px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/common/Footer.vue